/* Swiper Slide */
import Swiper from 'swiper/swiper-bundle.min.mjs'

// Hero Slide
const heroSlidePaginationRoute = () => {
    const items = document.querySelectorAll(heroSlideElClassName + " .swiper-pagination .swiper-pagination-bullet")
    items.forEach((item) => {
        item.addEventListener('click', evt => {
            if (evt.currentTarget.classList.contains('swiper-pagination-bullet-active')) {
                window.location.href = evt.currentTarget.dataset.href
            }
        })
    })
}

const heroSlideElClassName = ".hero-slide"
const heroSlide = new Swiper(`${heroSlideElClassName} .swiper`, {
    loop: false,
    allowTouchMove: true,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false
    },
    speed: 200,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    navigation: {
        nextEl: ".hero-slide .swiper-button-next",
        prevEl: ".hero-slide .swiper-button-prev",
    },
    pagination: {
        el: heroSlideElClassName + " .swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
            let item = document.querySelectorAll(heroSlideElClassName + ' .swiper-slide')[index]
            let title = item.dataset.title.replace(",", "<br>")
            let href = item.dataset.href
            return '<div class="' + className + '" data-href="'+href+'"><span>' + title + '</span><i class="ph-bold ph-arrow-up-right"></i></div>'
        },
    },
    on: {
        slideChangeTransitionStart: function () {
            $(`${heroSlideElClassName} .swiper-slide`).eq(this.activeIndex).find('.animate-content').removeClass('aos-init').removeClass('aos-animate')
            $(`${heroSlideElClassName} .swiper-slide`).eq(this.activeIndex).find('.animate-content').hide()
        },
        slideChangeTransitionEnd: function () {
            $(`${heroSlideElClassName} .swiper-slide`).eq(this.activeIndex).find('.animate-content').show()
            AOS.refreshHard()
        },

        init: function () {
            heroSlidePaginationRoute()
        }
    }
})

const heroSlide2TextEl = '.hero-slide-2 .text-swiper'
const heroSlide2Text = new Swiper(heroSlide2TextEl, {
    spaceBetween: 0,
    slidesPerView: "auto",
    freeMode: true,
    watchSlidesProgress: true,
    allowTouchMove: false,
    speed: 200,
    loop: true,
})

const heroSlide2GalleryEl = '.hero-slide-2 .gallery-swiper'
const heroSlide2Gallery = new Swiper(heroSlide2GalleryEl, {
    loop: true,
    autoplay: {
        delay: 5000,
    },
    speed: 200,
    navigation: {
        nextEl: ".hero-slide-2 .swiper-button-next",
        prevEl: ".hero-slide-2 .swiper-button-prev",
    },
    thumbs: {
        swiper: heroSlide2Text,
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
            spaceBetween: 0,
        },
        600: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        991: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
    },
})


const heroSlide3TextEl = '.hero-slide-3 .text-swiper .swiper'
const heroSlide3Text = new Swiper(heroSlide3TextEl, {
    spaceBetween: 0,
    slidesPerView: 1,
    freeMode: true,
    watchSlidesProgress: true,
    allowTouchMove: false,
    speed: 200,
})

const heroSlide3GalleryEl = '.hero-slide-3 .gallery-swiper'
const heroSlide3Gallery = new Swiper(heroSlide3GalleryEl, {
    loop: true,
    spaceBetween: 0,
    slidesPerView: 1,
    autoplay: {
        delay: 5000,
    },
    speed: 200,
    navigation: {
        nextEl: ".hero-slide-3 .swiper-button-next",
        prevEl: ".hero-slide-3 .swiper-button-prev",
    },
    thumbs: {
        swiper: heroSlide3Text,
    },
})

const herProjectListTabMenu = new Swiper(".hero-project-list-tab-menu .swiper", {
    freeMode: true,
    watchSlidesProgress: true,
    allowTouchMove: true,
    autoplay: false,
    slidesPerView: "auto",
    spaceBetween: 0,
});


document.querySelectorAll('.hero-project-list .hero-project-list-tab-content .swiper').forEach(el => {
    let swiper = new Swiper(el, {
        loop: true,
        speed: 200,
        centeredSlides: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false
        },
        roundLengths: true,
        centeredSlidesBounds: true,
        navigation: {
            nextEl: el.parentNode.querySelector('.swiper-button-next'),
            prevEl: el.parentNode.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
            0: {
                slidesPerView: 1.5,
                spaceBetween: 5,
            },
            768: {
                slidesPerView: 1.7,
                spaceBetween: 10,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            1300: {
                slidesPerView: 5,
                spaceBetween: 10,
            },
        },
    })
})

const brandsEl = '.brands .swiper'
const brands = new Swiper(brandsEl, {
    loop: true,
    autoplay: {
        delay: 1500,
        disableOnInteraction: false,
        pauseOnMouseEnter: false
    },
    speed: 200,
    breakpoints: {
        0: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        600: {
            slidesPerView: 3,
            spaceBetween: 45,
        },
        991: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
    },
})

document.querySelectorAll('.project-detail-page .social-areas .swiper').forEach(el => {
    let swiper = new Swiper(el, {
        loop: true,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false
        },
        speed: 200,
        centeredSlides: true,
        roundLengths: true,
        centeredSlidesBounds: true,
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
            el: el.querySelector(".swiper-pagination"),
            clickable: true
        },
    })
})

const locationsSlideEl = document.querySelector(".project-detail-page .locations .swiper")
const locationSlidePaginateRender = (e) => {
    let index = e.realIndex + 1,
        length = e.slides.length,
        targets = document.querySelectorAll('.project-detail-page .locations .info-page span')

    targets[1].innerHTML = length < 10 ? "/ 0"+length : "/ "+length
    targets[0].innerHTML = index < 10 ? "0"+index : index
}
const locationsSlide = new Swiper(locationsSlideEl, {
    loop: true,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
    },
    speed: 200,
    centeredSlides: true,
    roundLengths: true,
    centeredSlidesBounds: true,
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
        nextEl: locationsSlideEl?.querySelector('.swiper-button-next'),
        prevEl: locationsSlideEl?.querySelector('.swiper-button-prev'),
    },
    on: {
        slideChangeTransitionStart: function (e) {
            locationSlidePaginateRender(e)
        },
        slideChangeTransitionEnd: function (e) {

        },
        init: function (e) {
            locationSlidePaginateRender(e)
        }
    }
})

const projectGallerySlideEl = document.querySelector('.project-detail-page .gallery-slide .swiper')
const projectGallerySlide = new Swiper(projectGallerySlideEl, {
    loop: true,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
    },
    speed: 200,
    centeredSlides: true,
    roundLengths: true,
    centeredSlidesBounds: true,
    navigation: {
        nextEl: projectGallerySlideEl?.querySelector('.swiper-button-next'),
        prevEl: projectGallerySlideEl?.querySelector('.swiper-button-prev'),
    },
    breakpoints: {
        0: {
            slidesPerView: 1.3,
            spaceBetween: 0,
        },
        1024: {
            slidesPerView: 1.7,
            spaceBetween: 0,
        },
        1366: {
            slidesPerView: 3,
            spaceBetween: 0,
        },
    },
})

window.addEventListener('resize', () => {

})